<!-- Add any extra content that might be supplied with the component -->
<div class="extra-content">
  <ng-content></ng-content>
</div>

<div class="ts-tree-menu__sidebar">
  <ts-tree-menu
    title="Task Lists"
    [items]="tsTreeTaskLists"
    [actions]="tsTreeActions"
    (action)="onActionClicked($event)"
  ></ts-tree-menu>
</div>
